import StudyingProgramsApi from '@/api/studying-programs';

export default {
  namespaced: true,
  state: {
    programs: [],
  },

  mutations: {
    SET_PROGRAMS(state, val) {
      state.programs = val;
    },
  },
  actions: {
    async getPrograms({ commit }) {
      try {
        const programs = await StudyingProgramsApi.getPrograms();
        commit('SET_PROGRAMS', programs.data);
        return programs;
      } catch (e) {
        throw e;
      }
    },
    async updateOrCreateProgram ({ commit, dispatch }, data) {
      try {
        const program = await StudyingProgramsApi.createOrUpdateProgram(data)
        dispatch('getPrograms');
        return program
      } catch (e) {
        throw e;
      }
    },
    async deleteProgramRecord({commit, dispatch}, data) {
      try {
        const programResponse = await StudyingProgramsApi.removeProgram(data);
        return programResponse;
      } catch (e) {
        throw e;
      }
    }
  },

};
